import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Answers from '@root/db/entity/Answers';
import BarChart from '../../charts/BarChart';
import {
  CardBody,
  QuestionTypography,
} from '../../../styles/CardTextAndContainers';
import { countRanges } from '../../../utils/getBarChartData';
import { ResultCard, TitleContainer } from './styles';
import getResultText from '../../../utils/getResultText';

interface IProps {
  resultData: Answers;
  allAnswerData: Answers[];
}

const LeftCard = ({ resultData, allAnswerData }: IProps) => {
  const [resultText, setResultText] = useState<{
    text: string;
    resultTitle: string;
  } | null>(null);

  useEffect(() => {
    if (resultData) {
      setResultText(getResultText(resultData.score, resultData.helpedByBus));
    }
  }, [resultData]);

  const stats = countRanges(allAnswerData);

  const count = stats.map((stat) => stat.count);
  const ranges = stats.map((stat) => stat.range);

  return (
    <ResultCard>
      <TitleContainer>Your overall result</TitleContainer>

      <ScoreContainer>
        <BodyTypography>Your distributor relationship score is:</BodyTypography>
        <ScoreTypography>
          {resultData?.score || 'loading'} / 100
        </ScoreTypography>
      </ScoreContainer>
      <ChartContainer>
        <BarChart
          data={count}
          labels={ranges}
          userRange={resultData.range}
          yLabel="Number of responses"
          xLabel="Score range"
        />
      </ChartContainer>
      <InfoContainer>
        <QuestionTypography>
          {resultText?.resultTitle || 'loading'}
        </QuestionTypography>
        {resultText?.text ? (
          <CardBody dangerouslySetInnerHTML={{ __html: resultText.text }} />
        ) : (
          <CardBody>loading</CardBody>
        )}
      </InfoContainer>
    </ResultCard>
  );
};

const InfoContainer = styled.div``;

const ChartContainer = styled.div`
  width: 511px;
  height: 245px;
`;

const ScoreTypography = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 72px;
  letter-spacing: -0.5000000596046448px;
  text-align: left;
`;

const ScoreContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 15px 0px 15px 0px;
`;

const BodyTypography = styled.div`
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;

export default LeftCard;
